import { mergeProps } from '@zag-js/solid';
import { createSplitProps } from '../create-split-props';
import { ark } from '../factory';
import { runIfFn } from '../run-if-fn';
import { SwitchProvider } from './switch-context';
import { useSwitch } from './use-switch';
export const SwitchRoot = (props) => {
    const [switchProps, localProps] = createSplitProps()(props, [
        'checked',
        'dir',
        'disabled',
        'form',
        'getRootNode',
        'id',
        'ids',
        'invalid',
        'label',
        'name',
        'onCheckedChange',
        'required',
        'value',
    ]);
    const api = useSwitch(switchProps);
    const mergedProps = mergeProps(() => api().rootProps, localProps);
    const getChildren = () => runIfFn(props.children, api);
    return (<SwitchProvider value={api}>
      <ark.label {...mergedProps}>{getChildren()}</ark.label>
    </SwitchProvider>);
};
